import client from './client/index'
import session from './session.service'
import theme from './theme.service'

export default {
    client,
    session,
    theme
}